import { Drawer, Divider, Typography, Box, ModalClose } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

export function DrawerLayout({ title, headerButtons, wide, children }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Drawer 
      open 
      anchor="right" 
      size="md" 
      onClose={() => navigate('..')} 
      sx={{ 
        '.MuiDrawer-content': { 
          minWidth: isMobile ? '100%' : (wide ? '1000px' : '750px'), 
          width: isMobile ? '100%' : (wide ? '75%' : undefined),
          maxWidth: isMobile ? '100%' : undefined,
        }
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mx: { xs: 2, md: 3 }, 
        my: 2, 
        mr: { xs: 4, md: 7 }, 
        gap: 1 
      }}>
        <Typography level={isMobile ? 'h4' : 'h3'} sx={{ width: '100%' }}>{ title }</Typography>
        {headerButtons && <>{headerButtons}<Divider orientation="vertical" variant="middle" /></>}
      </Box>
      <ModalClose sx={{ mr: 1, mt: 1}} />                  
      <Box sx={{ px: { xs: 2, md: 3 }, pb: { xs: 2, md: 3 } }}>
        <Divider sx={{ mx: { xs: -2, md: -3 }, mb: 1 }} />
        { children }
      </Box>
    </Drawer>
  );
}
